import * as core from '../../../../../../../core'

import { query } from './training-implications-by-department.query'

export const RESOURCE = {
  payload: {
    alias: 'training.implications.by.department',
    description: 'Chart view of training implications by department',
    name: 'Training Implications by Department',
    query,
    variables: [],
  },
  type: core.quiver.Resource.Type.MosaicWidget,
} as const satisfies core.quiver.Resource<core.quiver.Resource.Type.MosaicWidget>
